<template>
  <v-dialog v-model="dialog" persistent max-width="700px">
    <v-container>
      <v-card>
        <v-toolbar class="headline" color="primary" dark
          >食事予約（一括）</v-toolbar
        >
        <v-card-text>
          <v-form ref="p1Form" v-model="p1Form" lazy-validation>
            <v-row align="center" no-gutters>
              <template>
                <v-col cols="12" sm="5" md="5" lg="5">
                  <RyouDateFormat
                    v-model="collectiveStartDate"
                    :value="collectiveStartDate"
                    :type="'date'"
                    :format="'$1/$2/$3'"
                    :label="'一括登録開始日'"
                    :min="mealDeadLineDay"
                    :max="getFutureDay()"
                    :rules="dateRules"
                    style="width: 40%"
                  ></RyouDateFormat>
                </v-col>
                <v-col class="text-center" cols="12" sm="2" md="2" lg="2">
                  <h2>{{ this.wavyLineMark }}</h2>
                </v-col>
                <v-col cols="12" sm="5" md="5" lg="5">
                  <RyouDateFormat
                    v-model="collectiveEndDate"
                    :value="collectiveEndDate"
                    :type="'date'"
                    :format="'$1/$2/$3'"
                    :label="'一括登録終了日'"
                    :rules="dateRules"
                    :min="selectMin"
                    :max="getFutureDay()"
                    style="width: 40%"
                  ></RyouDateFormat>
                </v-col>
              </template>
            </v-row>
            <v-container style="height: 200px; overflow-y: auto" fill-height>
              <template>
                <v-row
                  no-gutters
                  v-for="(item, index) in contentValue"
                  :key="index"
                >
                  <v-col align="center" cols="5">
                    <v-subheader>
                      <v-icon
                        large
                        color="blue"
                        v-if="item.reserve_flg"
                        @click="reserveFlgChange(item)"
                      >
                        mdi-check-circle
                      </v-icon>
                      <v-icon
                        large
                        v-if="!item.reserve_flg"
                        @click="reserveFlgChange(item)"
                      >
                        mdi-checkbox-blank-circle-outline
                      </v-icon>
                      <v-col class="pl-0">
                        {{ item.meal_name }}
                      </v-col>
                      <v-icon
                        large
                        color="blue"
                        v-if="item.holding_flg"
                        @click="holdingFlgChange(item)"
                      >
                        mdi-check-circle
                      </v-icon>
                      <v-icon
                        large
                        v-if="!item.holding_flg"
                        @click="holdingFlgChange(item)"
                      >
                        mdi-checkbox-blank-circle-outline
                      </v-icon>
                      {{ "残" }}
                    </v-subheader>
                  </v-col>
                </v-row>
              </template>
            </v-container>
          </v-form>

          <v-card-actions>
            <template>
              <v-container>
                <v-row dense>
                  <v-col align="center" cols="12" sm="4" md="4" lg="4">
                    <ryou-black-btn
                      :small="true"
                      :label="'一括登録'"
                      :handlerClick="submitInsert"
                      :disabled="collectiveBtnCtrl"
                    >
                    </ryou-black-btn>
                  </v-col>

                  <!--
                  <v-col align="center" cols="12" sm="4" md="4" lg="4">
                    <ryou-black-btn :small="true" :label="'一括解除'" :handlerClick="submitClear" :disabled="collectiveBtnCtrl">
                    </ryou-black-btn>
                  </v-col>
                  -->

                  <v-col align="center" cols="12" sm="4" md="4" lg="4">
                    <ryou-black-btn
                      :small="true"
                      :label="'閉じる'"
                      :handlerClick="handleCancel"
                      :disabled="closeBtnCtrl"
                      :iconCls="'mdi-close'"
                    >
                    </ryou-black-btn>
                  </v-col>
                </v-row>
              </v-container>
            </template>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
import RyouDateFormat from "@/components/formInput/RyouDateFormat.vue";
export default {
  name: "MealReservationCollectiveDialog",
  components: {
    RyouBlackBtn,
    RyouDateFormat,
  },
  mounted() {
    this.dateRules.push(this.GlobalRules.required);
  },
  data() {
    return {
      p1Form: true,
      dateRules: [],
      dialog: false,
      selectMin: "",
      wavyLineMark: "　～　",
      mealDeadLineDay: "",
      collectiveStartDate: "",
      collectiveEndDate: "",
      collectiveBtnCtrl: null,
      closeBtnCtrl: false,
      contentValue: [],
      groupOptionValue: "",
      reserveUserOptionValue: "",
      updateResult: {},
    };
  },
  created() {
    if (this.loadFlag == true) {
      this.selectedData();
    }
  },
  watch: {
    collectiveStartDate(value) {
      if (value != null && value != "") {
        this.selectMin = value;
      } else {
        this.selectMin = this.mealDeadLineDay;
      }
      let fromDate = new Date(Date.parse(this.collectiveStartDate));
      let toDate = new Date(Date.parse(this.collectiveEndDate));
      if (fromDate.getTime() > toDate.getTime()) {
        this.collectiveEndDate = "";
      }
    },
  },
  methods: {
    //クリックを閉じる
    handleCancel() {
      this.close();
    },
    getFutureDay() {
      let future = new Date();
      let tirdMonth = new Date(
        future.getFullYear(),
        future.getMonth() + this.$getMealCollectiveEndMonth() + 1,
        0
      );
      future.setMonth(future.getMonth() + this.$getMealCollectiveEndMonth());
      let futureMonth = (future.getMonth() + 1).toString();
      if (futureMonth.length == 1) {
        futureMonth = "0" + futureMonth;
      }
      return (
        future.getFullYear() + "-" + futureMonth + "-" + tirdMonth.getDate()
      ); // future.getDate();
    },
    //ページローディング要求インターフェース、取得値
    // パラメータ1:ダイアログデータ、パラメータ2:物件グループID、パラメータ3:ユーザID
    getInputValue(
      value,
      buildGroupSelectValue,
      reserveUserSelectValue,
      DeadLineDay
    ) {
      if (buildGroupSelectValue) {
        this.groupOptionValue = buildGroupSelectValue;
      }
      if (reserveUserSelectValue) {
        this.reserveUserOptionValue = reserveUserSelectValue;
      }
      if (value) {
        this.contentValue = value;
      }

      // 最も早い締め切り時間
      var limit_time_min = "23:59";
      // 最も遅い締め切り時間
      var limit_time_max = "00:00";
      // 食事料金マスタから締め切り時間取得
      this.contentValue.forEach((item) => {
        if (item.limit_time < limit_time_min) {
          limit_time_min = item.limit_time;
        }
        if (item.limit_time > limit_time_max) {
          limit_time_max = item.limit_time;
        }
      });
      // 時間と分に分割
      let hour_mins_min = limit_time_min.split(":");
      let hour_min = Number(hour_mins_min[0]);
      let mins_min = Number(hour_mins_min[1]);

      let hour_mins_max = limit_time_max.split(":");
      let hour_max = Number(hour_mins_max[0]);
      let mins_max = Number(hour_mins_max[1]);

      var date = new Date(DeadLineDay);
      var now = new Date();
      // 最も早い締め切り時間 ＜ 現在日時 ＜ 最も遅い締め切り時間の場合、締切日+1にする
      if (hour_min < now.getHours() && now.getHours() < hour_max) {
        date.setDate(date.getDate() + 1);
      } else if (hour_min == now.getHours() && mins_min < now.getMinutes()) {
        if (now.getHours() < hour_max) {
          date.setDate(date.getDate() + 1);
        } else if (now.getHours() == hour_max && now.getMinutes() < mins_max) {
          date.setDate(date.getDate() + 1);
        }
      }

      var month = ("00" + (date.getMonth() + 1)).slice(-2);
      var day = ("00" + date.getDate()).slice(-2);
      var deadLine = date.getFullYear() + "-" + month + "-" + day;

      this.mealDeadLineDay = deadLine;
      this.selectMin = deadLine;
      this.open();
    },
    // パラメータをクリア
    clearParameters() {
      this.mealDeadLineDay = "";
      this.collectiveStartDate = "";
      this.collectiveEndDate = "";
      this.$refs.p1Form.reset();
      this.$refs.p1Form.resetValidation();
      this.collectiveBtnCtrl = null;
      this.contentValue = [];
      this.groupOptionValue = "";
      this.reserveUserOptionValue = "";
    },
    submitInsert() {
      this.submit(true);
    },
    submitClear() {
      this.submit(false);
    },
    submit(value) {
      var valid = this.$refs.p1Form.validate();

      if (valid) {
        let updateResultBean = {
          build_group_id: this.groupOptionValue,
          edit_user_id: this.reserveUserOptionValue,
          collectiveUpdateStartDate: this.collectiveStartDate,
          collectiveUpdateEndDate: this.collectiveEndDate,
          reserve_entity: [],
          insert_clear_flg: value,
          user_id: this.$store.getters.getUserId,
        };
        this.updateResult = updateResultBean;

        this.contentValue.forEach((item) => {
          let updateItem = null;
          // 一括登録
          if (value) {
            updateItem = {
              meal_class: item.meal_class,
              reserve_flg: Number(item.reserve_flg).toString(),
              holding_flg: Number(item.holding_flg).toString(),
            };
          }
          //一括解除
          else {
            item.reserve_flg = false;
            item.holding_flg = false;
            updateItem = {
              meal_class: item.meal_class,
              reserve_flg: Number(false).toString(),
              holding_flg: Number(false).toString(),
            };
          }

          this.updateResult.reserve_entity.push(updateItem);
        });

        this.collectiveBtnCtrl = true;
        this.closeBtnCtrl = true;

        this.putRequest(
          "/mealReservation/mealReserveCollectiveUpdate",
          this.updateResult,
          this.$store.getters.getUserToken
        ).then(() => {
          this.collectiveBtnCtrl = false;
          this.closeBtnCtrl = false;
        });
      }
    },
    reserveFlgChange(value) {
      value.reserve_flg = !value.reserve_flg;
      //予約なしに変更時、取置有無をなしにする
      if (!value.reserve_flg) {
        if (value.holding_flg) {
          value.holding_flg = false;
        }
      }
    },
    holdingFlgChange(value) {
      value.holding_flg = !value.holding_flg;
      //取置ありに変更時、予約有無をありにする
      if (value.holding_flg) {
        if (!value.reserve_flg) {
          value.reserve_flg = true;
        }
      }
    },
    close() {
      this.dialog = false;

      this.clearParameters();
      this.$emit("reCalendar");
      // 2024.11.25 kouta.noborisaka 三井化学（市原工場）:食事予約（一括）のポップアップを閉じたときに、寮食費計算の表を再取得する
      this.$emit("reCalc", true);
    },
    open() {
      this.dialog = true;
    },
  },
};
</script>

<style scoped>
.noPaddingBtm {
  height: 48px;
  padding-bottom: 0px;
}

.noPaddingTopBtm {
  padding-top: 0px;
  padding-bottom: 0px;
}

.HigotoTextBox {
  outline: 1px solid rgb(0, 225, 255);
}
</style>
